import React from 'react';
import { CalendarOff } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import CountryFlag from '../common/CountryFlag';
import './UpcomingTimeOff.css';

function UpcomingTimeOff({ timeoff, loading, timeframe }) {
  const timeframeLabels = {
    today: 'today',
    week: 'this week',
    month: 'this month',
  };

  if (loading) {
    return (
      <div className="upcoming-timeoff">
        <div className="upcoming-timeoff-header">
          <CalendarOff size={16} strokeWidth={2} />
          <h3>Upcoming Time Off</h3>
        </div>
        <div className="upcoming-timeoff-loading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="upcoming-timeoff">
      <div className="upcoming-timeoff-header">
        <CalendarOff size={16} strokeWidth={2} />
        <h3>Upcoming Time Off</h3>
        {timeoff && timeoff.length > 0 && (
          <span className="upcoming-timeoff-count">{timeoff.length}</span>
        )}
      </div>

      {(!timeoff || timeoff.length === 0) ? (
        <div className="upcoming-timeoff-empty">
          No upcoming time off {timeframeLabels[timeframe] || 'this week'}
        </div>
      ) : (
        <div className="upcoming-timeoff-list">
          {timeoff.map((entry) => {
            const days = entry.days || [];
            const sortedDays = [...days].sort((a, b) => a.date.localeCompare(b.date));
            const firstDate = sortedDays[0]?.date;
            const lastDate = sortedDays[sortedDays.length - 1]?.date;
            const displayName = entry.first_name && entry.last_name
              ? `${entry.first_name} ${entry.last_name}`
              : entry.name;

            let dateRange;
            if (!firstDate) {
              dateRange = '';
            } else if (firstDate === lastDate) {
              dateRange = format(parseISO(firstDate), 'MMM d');
            } else {
              dateRange = `${format(parseISO(firstDate), 'MMM d')} - ${format(parseISO(lastDate), 'MMM d')}`;
            }

            return (
              <div key={entry.request_id} className="upcoming-timeoff-item">
                <div className="upcoming-timeoff-person">
                  <span className="upcoming-timeoff-name">{displayName}</span>
                  <div className="upcoming-timeoff-meta">
                    {entry.department && (
                      <span className="upcoming-timeoff-dept">{entry.department}</span>
                    )}
                    {entry.country_code && (
                      <>
                        <CountryFlag code={entry.country_code} size="small" />
                        <span className={`upcoming-timeoff-country country-tag-${entry.country_code?.toLowerCase()}`}>
                          {entry.country_code}
                        </span>
                      </>
                    )}
                  </div>
                </div>
                <div className="upcoming-timeoff-right">
                  <span className="upcoming-timeoff-dates">{dateRange}</span>
                  <span className={`upcoming-timeoff-status status-${entry.status}`}>
                    {entry.status}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default UpcomingTimeOff;
